"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputContainer = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../../styles/widths");

var _palette = require("../../../../styles/palette");

var _templateObject, _templateObject2;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  gap: 2px;\n\n  & > span {\n    padding-top: 4px;\n  }\n"])));

exports.Container = Container;
Container.displayName = 'Container';

var InputContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n\n  & .PhoneInputInput {\n\n    outline: none;\n    border: none;\n    border-width: ", "px;\n    margin-bottom: ", "px;\n    border-bottom-style: solid;\n    border-color: ", ";\n    font-size: 16px;\n    padding: ", "px;\n    padding-left: 0;\n    font-weight: ", ";\n    line-height: 22px;\n    color: ", ";\n\n    &:focus {\n      border-color: ", ";\n      margin-bottom: 0px;\n      border-bottom-width: 2px;\n    }\n  }\n  & .PhoneInputInput::placeholder {\n    color: ", ";\n  }\n\n  span {\n    padding-left: 41px;\n    font-size: 12px;\n    color: ", ";\n  }\n"])), function (_ref) {
  var error = _ref.error;
  return error ? 2 : 1;
}, function (_ref2) {
  var error = _ref2.error;
  return error ? 0 : 1;
}, function (_ref3) {
  var error = _ref3.error;
  return error ? _palette.palette.error : _palette.palette.bobBlack;
}, _widths.widths.base / 2, _widths.font.regular, _palette.palette.bobBlack, function (_ref4) {
  var error = _ref4.error;
  return error ? _palette.palette.error : _palette.palette.link;
}, function (_ref5) {
  var error = _ref5.error;
  return error ? _palette.palette.error : _palette.palette.bobBlack;
}, _palette.palette.error);

exports.InputContainer = InputContainer;